module.exports = __webpack_public_path__ + "static/data-1da6aae7b3ea2ddf46a3fc77aa8d6431.mp4";